<template>
  <transition
    enter-active-class="transition-opacity duration-300"
    leave-active-class="transition-opacity duration-300"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    mode="out-in"
  >
    <component v-bind="component" />
  </transition>
</template>

<script>
import DowngradePage from "./components/Downgrade";
import MaintenancePage from "./components/Maintenance";

const Velocity =
  typeof window !== "undefined" ? require("velocity-animate") : null;

export default {
  metaInfo: () => ({
    title: "Downgrade - Account | Motion Array"
  }),

  data() {
    const isMaintenance = this.$store.state.user.plan === 'monthly_maintenance_2020'
    const gateway = this.paymentProvider

    let component = {
      is: MaintenancePage,
      downgradeHandler: this.downgradeHandler,
    }

    if (isMaintenance || gateway === 'paypal') {
      component = {
        is: DowngradePage
      }
    }

    return {
      component
    };
  },
  computed: {
    paymentProvider() {
      return this.$store.getters.paymentProvider;
    }
  },

  methods: {
    downgradeHandler() {
      this.component = {
        is: DowngradePage,
      };

      this.$nextTick(() => {
        Velocity(document.body, "scroll");
      });
    },
  },
};
</script>
